import gql from 'graphql-tag';

const QUERY_GENERATE_COMMISSION_REPORT_FILE = gql`
	query GenerateCommissionReportFile($reportID: String!, $type: Int!, $depositInfo: DepositInfo) {
		generateCommissionReportFile(reportID: $reportID, type: $type, depositInfo: $depositInfo)
	}
`;

export default QUERY_GENERATE_COMMISSION_REPORT_FILE;